<template>
  <div id="page-searchGlobal">
    <article class="content">
      <section class="search-wrap">
        <input
          type="text"
          v-model="keywords_search"
          class="input-search"
          @keyup.enter="handleSearchMsg"
        />
        <span class="btn-search" @click="handleSearchMsg">搜索</span>
      </section>
      <section class="search-result">
        <div class="tab-head">
          <span class="tab-item" :class="{'active':isShowGroup}" @click="handleChangeTab(1)">群组监测任务</span>
          <span class="tab-item" :class="{'active':!isShowGroup}" @click="handleChangeTab(2)">媒体监测任务</span>
        </div>
        <div class="tab-content" v-if="(!isTaskListEmpty)||(!isMsgListEmpty)">
          <section class="section-jobRelated" v-show="jobList.length">
            <p class="jobRelated-label">相关任务：</p>
            <ul class="jobRelated-list">
              <li
                class="jobRelated-listItem"
                v-for="item in jobList"
                :key="item.jobId"
                @click="toRelativeJob(item.jobId)"
              >
                <span class="jobRelated-listItem-label">{{item.jobName}}</span>
              </li>
            </ul>
          </section>
          <section class="section-messageRelated-group" v-show="(isShowGroup&&totalNum_group)||((!isShowGroup)&&totalNum_media)">
            <p class="messageRelated-label" v-if="isShowGroup==true">相关聊天记录：</p>
            <p class="messageRelated-label" v-else>相关信息：</p>
            <p
              class="tip"
              v-if="isShowGroup"
            >近一个月内，共搜索到{{totalNum_group}}条信息，其中敏感信息{{positiveNum_group}}条，负面信息{{negativeNum_group}}条</p>
            <p
              class="tip"
              v-else
            >近一个月内，共搜索到{{totalNum_media}}条信息，其中正面信息{{positiveNum_media}}条，中性信息{{middleNum_media}}条，负面信息{{negativeNum_media}}条</p>
            <div class="listMessage-wrapper">
              <ul class="listMessage">
                <li class="listMessage-item" v-for="(item, index) in listMessage" :key="item.id">
                  <div class="ls">
                    <Tag
                      :color="item.propertyColor"
                      class="tag-property"
                      style="width:56px; line-height:23px; text-align:center"
                    >{{item.propertyLabel}}</Tag>
                  </div>
                  <div class="rs">
                    <div
                      class="rs-link"
                      @click="gotoSource(item)"
                      :class="{'isLink':!isShowGroup}"
                    >
                      <div class="message-title-group" v-if="isShowGroup">
                        <Icon type="ios-star" color="orange" size="24" v-if="item.followed" style="cursor: pointer;" @click="cancelFlowMeaasge(index,item.idOri)"/>
                        <Icon type="ios-star-outline" color="orange" size="24" style="cursor: pointer;" v-else @click="flowMessage(index,item.idOri)"/>
                        <div
                          class="message-link-toSpecGroup"
                          @click="toSpecGroup(item.senderIdOrigin,item.jobId)"
                          style="display: inline-block"
                        >
                          <span class="groupMemberName">{{item.groupMemberName}}</span>
                          <span class="groupNum">{{item.groupNum}}</span>
                          <span class="relativeTask">(所属任务: {{item.jobName}})</span>
                        </div>
                      </div>
                      <div class="message-title-media" v-else>
                        <span class="title-media" v-html="item.title"></span>
                        <span class="relativeTask">(所属任务: {{item.jobName}})</span>
                      </div>
                      <div class="message-content" v-html="item.messageContent"></div>
                      <div class="message-footer-group" v-if="isShowGroup">
                        <span class="messageTime">{{item.date}} {{item.time}}</span>
                        <span
                          class="checkContext"
                          :id="'checkContext-'+item.id"
                          @click="handleClickCheckContext($event,item.id)"
                        >查看上下文</span>
                      </div>
                      <div class="message-footer-media" v-else>
                        <div class="message-footer-news" v-if="item.source_name==='新闻'">
                          <div class="message-footer-ls">
                            <div class="keywords-wrapper">
                              关键词：
                              <span class="keywords" v-html="item.keywords"></span>
                            </div>
                            <div class="frequency-wrapper">
                              词频：
                              <span class="frequency" v-html="item.frequency"></span>
                            </div>
                            <div class="messageOrigin-wrapper">
                              来源：
                              <span class="messageOrigin">{{item.origin}}</span>
                            </div>
                          </div>
                        </div>
                        <div class="message-footer-weibo" v-if="item.source_name==='微博'">
                          <div class="message-footer-ls">
                            <div class="fansNum-wrapper">
                              粉丝数：
                              <span class="fansNum">{{item.followers_num}}</span>
                            </div>
                            <div class="commentNum-wrapper">
                              评论量：
                              <span class="commentNum">{{item.comment_num}}</span>
                            </div>
                            <div class="likeNum-wrapper">
                              点赞量：
                              <span class="likeNum">{{item.like_num}}</span>
                            </div>
                            <div class="forwardNum-wrapper">
                              转发量：
                              <span class="forwardNum">{{item.forward_num}}</span>
                            </div>
                          </div>
                        </div>
                        <div class="message-footer-pubilc" v-if="item.source_name==='公众号'">
                          <div class="message-footer-ls">
                            <div class="publicAccount-wrapper">
                              公众号：
                              <span class="publicAccount">{{item.origin}}</span>
                            </div>
                            <div class="frequency-wrapper">
                              词频：
                              <span class="frequency" v-html="item.frequency"></span>
                            </div>
                            <div class="author-wrapper">
                              作者：
                              <span class="author">{{item.author}}</span>
                            </div>
                          </div>
                          <div class="message-footer-rs">
                            <div
                              class="similarArticle"
                              @click="checkSimilarArticle([item.uniqueId,item.id,item.articleNum])"
                              v-show="isRepeat"
                            >相似文章: {{item.articleNum}}</div>
                          </div>
                        </div>
                        <div class="message-footer-tieba" v-if="item.source_name==='贴吧'">
                          <div class="author-wrapper">
                            发帖人：
                            <span class="author">{{item.author}}</span>
                          </div>
                          <div class="totalFloors-wrapper">
                            楼层总数：
                            <span class="totalFloors">{{item.floor_count}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </section>
          <section class="section-page" v-show="isShowPage">
            <Page
              :total="listMessage_totalNum"
              :current="currentPage"
              @on-change="changePage"
              show-total
              class="page"
            />
          </section>
        </div>
        <div class="empty-placeholder" v-else>很抱歉，未能找到相关搜索结果！</div>
      </section>
    </article>
    <!-- 模态框------------------------------------------------------------------>
    <dialog-context
      ref="dialogContext"
      :currentMsgId="currentMsgId"
      :dialogGroupName="dialogGroupName"
    ></dialog-context>
    <!-- loading动画 --------------------------------------------------------------------------->
    <loading :isLoading="isLoadingMsg||isLoadingJob"></loading>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //搜索框中的输入
      keywords_search: "",
      //是否展示<群组监测>模块
      isShowGroup: true,
      //搜索结果--相关任务
      jobList: [],
      //信息总数目--群组
      totalNum_group: 0,
      //非负面信息数目--群组
      positiveNum_group: 0,
      //负面信息数目--群组
      negativeNum_group: 0,
      //信息总数目--媒体
      totalNum_media: 0,
      //正面信息数目--媒体
      positiveNum_media: 0,
      //中性信息数目--媒体
      middleNum_media: 0,
      //负面信息数目--媒体
      negativeNum_media: 0,
      //正在获取任务列表
      isLoadingJob: false,
      //正在获取消息列表
      isLoadingMsg: false,
      //消息列表--群组的所有数据
      listMessage: [],
      //消息列表数据查询条件
      queryData: {
        startTime:
          new Date().setHours(0, 0, 0, 0) - 1000 * 60 * 60 * 24 * (30 - 1),
        endTime: new Date().getTime(),
        keyWords: "",
        page: 1,
        showType: 1 //默认是查询群组数据
      },
      //消息列表的总数据数目
      listMessage_totalNum: 0,
      //是否展示分页：没有数据时隐藏
      isShowPage: true,
      //当前展示的页码
      currentPage: 1,
      //控制显示群对话记录的模态框
      isShowDialogGroupMessages: false,
      //当前选中的消息id
      currentMsgId: "",
      //群对话记录模态框群名称
      dialogGroupName: "",
      //任务列表是否为空
      isTaskListEmpty: false,
      //消息列表是否为空
      isMsgListEmpty: false
    };
  },
  created() {
    this.queryData.keyWords = this.keywords_search = this.$route.query.keywords_search;
    //获取近30天的时间戳
    this.queryData.startTime =
      new Date().setHours(0, 0, 0, 0) - 1000 * 60 * 60 * 24 * 29;
    this.queryData.endTime = new Date().getTime(); //终止时间是现在时刻
  },
  mounted() {
    this.searchJob();
    this.searchMsg();
  },
  methods: {

    flowMessage(index,id){
      this.$ajax({
        method: "get",
        url: "/focusOn/setFocus",
        params: {
          "id": id,
          "type": 5
        }
      })
      .then(res => {
        if (res.data.success) {
          if (res.data.data) {
            this.$Message.success("关注成功")
          } else {
            this.$Message.error("关注失败")
          }
        }
      })
      .catch(err => {
        this.$Message.error("服务器错误");
          console.log(err);
      });

      //debugger;
      if(this.listMessage[index].followed){
        this.listMessage[index].followed = false;
      }
      else{
        this.listMessage[index].followed = true;
      }
      this.$set(this.listMessage, index, this.listMessage[index])
      console.log(index,this.listMessage[index],this.listMessage[index].followed);
    },

    cancelFlowMeaasge(index,id) {
      this.$ajax({
        method: "get",
        url: "/focusOn/cancelFocus",
        params: {
          "id": id,
          "type": 5
        }
      })
      .then(res => {
        if (res.data.success) {
          if (res.data.data) {
            this.$Message.success("取消关注成功")
          } else {
            this.$Message.error("取消关注失败")
          }
        }
      })
      .catch(err => {
        this.$Message.error("服务器错误");
          console.log(err);
      });

      //debugger;
      if(this.listMessage[index].followed){
        this.listMessage[index].followed = false;
      }
      else{
        this.listMessage[index].followed = true;
      }
      this.$set(this.listMessage, index, this.listMessage[index])
      console.log(index,this.listMessage[index],this.listMessage[index].followed);
    },

    //在导航栏里的搜索框中搜索时，刷新页面数据
    refreshPage() {
      this.queryData.keyWords = this.keywords_search = this.$route.query.keywords_search;
      this.searchJob();
      this.searchMsg();
    },
    //搜索任务
    searchJob() {
      if (this.isShowGroup) {
        //当前模块--群组监测任务
        this.queryData.showType = "1";
      } else {
        //当前模块--媒体监测任务
        this.queryData.showType = "2";
      }
      this.getJobData();
    },
    //搜索消息列表
    searchMsg() {
      if (this.isShowGroup) {
        //当前模块--群组监测任务
        this.queryData.showType = "1";
      } else {
        //当前模块--媒体监测任务
        this.queryData.showType = "2";
      }
      this.getMsgData();
    },
    //在搜索框中输入回车/点击搜索按钮
    handleSearchMsg() {
      this.keywords_search = this.keywords_search.trim();
      if (this.keywords_search.length == 1) {
        this.$Message.error("输入字数过少");
        return;
      } else if (this.keywords_search.length > 30) {
        this.$Message.error("输入字数过长");
        return;
      } else if (this.keywords_search.length == 0) {
        this.$Message.error("请输入中英文字符");
        return;
      }
      var reg = /[A-Za-z0-9\u4e00-\u9fa5]/g;
      if (!reg.test(this.keywords_search)) {
        this.$Message.error("请输入中英文字符");
        return;
      }
      //还原页码
      this.currentPage = this.queryData.page = 1;
      this.queryData.keyWords = this.keywords_search;

      this.searchJob();
      this.searchMsg();
    },
    //获取任务列表
    getJobData() {
      if (this.isLoadingJob) return;
      this.isLoadingJob = true;
      let queryData_job = {
        keyWords: this.queryData.keyWords,
        showType: this.queryData.showType
      };
      this.$ajax({
        method: "get",
        url: "./search/jobName",
        params: queryData_job
      })
        .then(res => {
          this.isLoadingJob = false;
          if (res.data.success) {
            if (res.data.data) {
              //先清空jobList中的数据
              this.jobList = [];
              let resData = res.data.data;
              if (resData.length > 0) {
                this.isTaskListEmpty = false;
                resData.forEach(item => {
                  this.jobList.push({
                    jobId: item.jobId,
                    jobName: item.jobName
                  });
                });
                this.jobList = this.jobList.slice(0, 12);
              } else {
                this.isTaskListEmpty = true;
              }
            }
          } else {
            if (res.data.code !== 405) {
              this.$Message.error("服务器错误");
            }
          }
        })
        .catch(err => {
          this.isLoadingJob = false;
          this.$Message.error("服务器错误");
          console.log(err);
        });
    },
    //获取消息列表
    getMsgData() {
      if (this.isLoadingMsg) return;
      this.isLoadingMsg = true;
      //发送ajax请求
      this.$ajax({
        method: "get",
        url: "./search/data",
        params: this.queryData
      })
        .then(res => {
          this.isLoadingMsg = false;
          if (res.data.success) {
            //先清空listMessage中的数据
            this.listMessage = [];
            //还原消息数量统计
            this.positiveNum_group = this.negativeNum_group = this.totalNum_group = this.positiveNum_media = this.middleNum_media = this.negativeNum_media = this.totalNum_media = 0;
            let resData = res.data.data.datas;
            if (resData.length > 0) {
              this.isMsgListEmpty = false;
              this.isShowPage = true; //如果消息数不为0，则显示分页
              if (this.isShowGroup) {
                //如果是群组消息列表
                resData.forEach(item => {
                  this.listMessage.push({
                    id: item.index_id,
                    idOri: item.id,
                    jobId: item.job_id,
                    jobName: item.jobName || "暂无",
                    propertyColor: item.feeling == "0" ? "success" : "error",
                    propertyLabel: item.feeling == "0" ? "敏感" : "负面",
                    feeling: item.feeling,
                    groupMemberName: `${item.sendMsgName}(${item.senderId})`,
                    groupMemberId: item.senderId,
                    groupNum: `${item.groupName}`,
                    messageContent: item.msg,
                    keyWords: item.warning_key_words,
                    date: this.formatDate(item.create_time),
                    time: this.formatTime(item.create_time),
                    senderIdOrigin: item.senderIdOrigin,
                    followed: item.followed
                  });
                });
                //更新消息数目统计
                this.positiveNum_group = res.data.data.feeling["0"]||0;
                this.negativeNum_group = res.data.data.feeling["1"]||0;
                this.totalNum_group = this.listMessage_totalNum = res.data.data.total||0;
              } else {
                //如果是媒体消息列表
                resData.forEach(item => {
                  this.listMessage.push({
                    id: item.index_id,
                    jobName: item.jobName || "暂无",
                    propertyColor: (feeling=> {
                      let tagColor = "error";
                      switch (feeling) {
                        case "0":
                          //中性
                          tagColor = "warning";
                          break;
                        case "1":
                          //负面
                          tagColor = "error";
                          break;
                        case "2":
                          //正面
                          tagColor = "success";
                          break;
                        default:
                          break;
                      }
                      return tagColor;
                    })(item.feeling),
                    propertyLabel: (feeling=> {
                      let tagLabel = "error";
                      switch (feeling) {
                        case "0":
                          //中性
                          tagLabel = "中性";
                          break;
                        case "1":
                          //负面
                          tagLabel = "负面";
                          break;
                        case "2":
                          //正面
                          tagLabel = "正面";
                          break;
                        default:
                          break;
                      }
                      return tagLabel;
                    })(item.feeling),
                    title: (item=> {
                      let title = "";
                      let search_type = item.search_type;
                      switch (search_type) {
                        case "新闻":
                          title = item.title;
                          break;
                        case "微博":
                          title = item.author;
                          break;
                        case "公众号":
                          title = item.title;
                          break;
                        case "贴吧":
                          title = `[${item.bar_name}吧] ${item.title}`;
                          break;
                        default:
                          break;
                      }
                      return title;
                    })(item),
                    sourceUrl: item.source_url,
                    messageContent: item.content,
                    origin: item.source_name,
                    isWarn: item.isWarn,
                    date: this.formatDate(parseInt(item.publishTime)),
                    time: this.formatTime(parseInt(item.publishTime)),
                    keywords: item.search_words,
                    frequency: (keyword_match=> {
                      let frequency = "";
                      //先删除所有count为0的数组
                      keyword_match = keyword_match.filter(item => {
                        return item.count > 0;
                      });
                      //然后对剩余数组进行排序
                      let arr_frequency = keyword_match
                        .sort((a, b) => b.count - a.count)
                        .slice(0, 2);
                      if (arr_frequency.length === 2) {
                        frequency = `${arr_frequency[0].keyword}(${arr_frequency[0].count})&nbsp;&nbsp;${arr_frequency[1].keyword}(${arr_frequency[1].count})`;
                      } else if (arr_frequency.length === 1) {
                        frequency = `${keyword_match[0].keyword}(${keyword_match[0].count})`;
                      }
                      return frequency;
                    })(item.keyword_match ? item.keyword_match : []),
                    followers_num: item.followers_num || 0,
                    comment_num: item.comment_num || 0,
                    like_num: item.like_num || 0,
                    forward_num: item.forward_num || 0,
                    author: item.author,
                    source_name: item.search_type,
                    floor_count: item.floor_count || 0,
                    update_time: item.update_time || 0,
                    urlid: item.id || ''
                  });
                });
                //更新消息数目统计
                this.positiveNum_media = res.data.data.feeling["2"]||0;
                this.middleNum_media = res.data.data.feeling["0"]||0;
                this.negativeNum_media = res.data.data.feeling["1"]||0;
                this.totalNum_media = this.listMessage_totalNum = res.data.data.total||0;
              }
              //根据搜索关键词标红消息标题或内容
              this.markKeywords();
            } else {
              this.isMsgListEmpty = true;
              this.isShowPage = false; //如果消息数为0，则隐藏分页
            }
          } else {
            if (res.data.code !== 405) {
              this.$Message.error("服务器错误");
            }
          }
        })
        .catch(err => {
          this.isLoadingMsg = false;
          this.$Message.error("服务器错误");
          console.log(err);
        });
    },
    //切换tab,1:群组,2:媒体
    handleChangeTab(param) {
      //防止用户重复点击
      if (this.isShowGroup && param === 1) return;
      if (!this.isShowGroup && param === 2) return;
      this.queryData.showType = param;
      this.isShowGroup = param === 1 ? true : false;
      //还原页码
      this.currentPage = this.queryData.page = 1;
      //更新搜索词
      this.queryData.keyWords = this.keywords_search;
      this.getJobData();
      this.getMsgData();
    },
    //点击qq/微信群跳转到成员发言记录页面
    toSpecGroup(groupMemberId,jobId) {
      let routeData = this.$router.resolve({
        path: "/groupSpec_group",
        query: {
          senderId: groupMemberId,
          jobId: jobId
        }
      });
      window.open(routeData.href, "_blank");
    },
    //如果显示的是媒体消息，则点击跳转到消息来源页
    gotoSource(item) {
      if(this.isShowGroup) return
      if(item.source_name == '公众号'){
        let date = new Date();
        let nowTime = date.getTime();
        if(nowTime - parseInt(item.update_time) > 6*60*60*1000){
        console.log('guoqi')

          window.open('./wechat?id=' + item.urlid)
        }else{
          window.open(item.sourceUrl);
        }
      }else{
        window.open(item.sourceUrl);
      }
    },
    //点击<相关任务>的任务列表，跳转到相关页面并定位到相关任务
    toRelativeJob(id) {
      let path = this.isShowGroup ? "/groupSpec" : "/mediaSpec";
      this.$router.push({
        path,
        query: {
          jobId: id
        }
      });
    },
    //标红相关文章标题/内容，并保证标红的第一个关键词前后最多只有40个字
    markKeywords() {
      let arr_keyWords = this.keywords_search.split(" ");
      //先找到第一个关键词
      for (let i = 0; i < this.listMessage.length; i++) {
        if (this.listMessage[i].messageContent.length > 80) {
          //如果文本内容超过80个字，找到文本中第一个关键词的位置，将其标红，然后前后截取不大于40个字符
          let firstKeywordIndex = this.listMessage[i].messageContent.indexOf(
            arr_keyWords[0]
          );
          if (firstKeywordIndex !== -1) {
            let text_before = this.listMessage[i].messageContent.substring(
              0,
              firstKeywordIndex
            );
            if (text_before.length > 40) {
              text_before =
                "..." + text_before.substring(text_before.length - 40);
            }
            let text_after = this.listMessage[i].messageContent.substring(
              firstKeywordIndex + arr_keyWords[0].length
            );
            if (text_after.length > 40) {
              text_after = text_after.substring(0, 40) + "...";
            }
            this.listMessage[i].messageContent =
              text_before +
              `<mark style="color:red">${arr_keyWords[0]}</mark>` +
              text_after;
          } else {
            this.listMessage[i].messageContent =
              this.listMessage[i].messageContent.substring(0, 80) + "...";
          }
        } else {
          //如果文本内容不超过80个字，直接标红文本内容中第一个关键词即可
          this.listMessage[i].messageContent = this.listMessage[
            i
          ].messageContent
            .split(arr_keyWords[0])
            .join(`<mark style="color:red">${arr_keyWords[0]}</mark>`);
        }
      }
      //确保文本总长度不大于80之后，在标红其他关键词
      for (let i = 0; i < this.listMessage.length; i++) {
        for (let j = 1; j < arr_keyWords.length; j++) {
          this.listMessage[i].messageContent = this.listMessage[
            i
          ].messageContent
            .split(arr_keyWords[j])
            .join(`<mark style="color:red">${arr_keyWords[j]}</mark>`);
        }
      }
      //如果是媒体消息，还要标红题目
      if (!this.isShowGroup) {
        for (let i = 0; i < this.listMessage.length; i++) {
          for (let j = 0; j < arr_keyWords.length; j++) {
            this.listMessage[i].title = this.listMessage[i].title
              .split(arr_keyWords[j])
              .join(`<mark style="color:red">${arr_keyWords[j]}</mark>`);
          }
        }
      }
    },
    //点击<查看上下文>按钮
    handleClickCheckContext(e,id) {
      //更新当前选中的消息id
      console.log(id);
      e.stopPropagation();
      this.currentMsgId = id;
      //获取该信息数据
      let messageData = this.listMessage.filter(item => item.id === id)[0];
      //更新群名称和群号码
      this.dialogGroupName = messageData.groupNum.trim();
      //初始化模态框
      this.$refs.dialogContext.showDialog();
    },
    //切换页码
    changePage(page) {
      //更新页码
      this.currentPage = this.queryData.page = page;
      this.getMsgData();
    }
  },
  watch: {
    //一旦在导航里的搜索框进行搜索，路由发生变化，则重新进行查询
    $route: "refreshPage"
  }
};
</script>

<style lang="less">
@import "../../../style/common.less";
#page-searchGlobal {
  .content {
    margin: 0 auto;
    margin-top: 18px;
    min-height: 700px;
    width: 1160px;
    background: #fff;
    box-shadow: 0 0 16px 0 #f3f4f7;
    box-sizing: border-box;
    padding: 44px 98px 48px 98px;
    .search-wrap {
      height: 45px;
      display: flex;
      justify-content: flex-start;
      .input-search {
        height: 44px;
        width: 597px;
        border: 1px solid #d8d9dc;
        border-radius: 4px 0 0 4px;
        font-family: PingFangSC-Regular;
        font-size: 18px;
        outline: none;
        padding-left: 12px;
      }
      .btn-search {
        height: 44px;
        width: 130px;
        line-height: 44px;
        border-radius: 0 4px 4px 0;
        font-family: PingFangSC-Regular;
        font-size: 18px;
        color: #333333;
        background: #4574ff;
        color: #fff;
        position: relative;
        cursor: pointer;
        transition: all 0.2s ease;
        box-sizing: border-box;
        padding-left: 25px;
        &::before {
          content: "";
          display: inline-block;
          position: absolute;
          height: 20px;
          width: 20px;
          left: 30px;
          top: 50%;
          transform: translateY(-50%);
          background: url("https://static.rong360.com/upload/png/78/f4/78f4d251dbd13c0f9ad0996591bb09f5.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          background-position: center;
        }
        &:hover {
          opacity: 0.8;
        }
      }
    }
    .search-result {
      margin-top: 37px;
      .tab-head {
        height: 60px;
        border-bottom: 1px solid #efeff4;
        display: flex;
        justify-content: flex-start;
        .tab-item {
          display: inline-block;
          height: 60px;
          line-height: 60px;
          font-family: PingFangSC-Medium;
          font-size: 18px;
          color: #333333;
          margin-right: 80px;
          box-sizing: border-box;
          border-bottom: 3px solid transparent;
          cursor: pointer;
          user-select: none;
        }
        .active {
          border-bottom: 3px solid #415af6;
        }
      }
      .tab-content {
        padding-top: 25px;
        .section-jobRelated {
          .jobRelated-label {
            text-align: left;
            font-family: PingFangSC-Medium;
            font-size: 16px;
            color: #333333;
          }
          .jobRelated-list {
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-start;
            margin-top: 10px;
            .jobRelated-listItem {
              flex: 0 0 25%;
              height: 40px;
              text-align: left;
              .jobRelated-listItem-label {
                display: inline-block;
                border: 1px solid #999999;
                border-radius: 3px;
                padding: 0 15px;
                height: 30px;
                line-height: 28px;
                font-family: PingFangSC-Regular;
                font-size: 16px;
                color: #333333;
                letter-spacing: 0;
                cursor: pointer;
                &:hover {
                  opacity: 0.8;
                }
              }
            }
          }
        }
        .section-messageRelated-group {
          text-align: left;
          font-size: 16px;
          margin-top: 30px;
          .messageRelated-label {
            font-family: PingFangSC-Medium;
            color: #333333;
          }
          .tip {
            font-family: PingFangSC-Regular;
            color: #999999;
            line-height: 30px;
          }
          .listMessage-wrapper {
            margin-top: 20px;
            .listMessage {
              .listMessage-item {
                overflow: hidden;
                margin-bottom: 10px;
                .ls {
                  float: left;
                }
                .rs {
                  float: left;
                  width: 800px;
                  padding-left: 15px;
                  .isLink {
                    cursor: pointer;
                  }
                  .message-title-group {
                    text-align: left;
                    .message-link-toSpecGroup {
                      display: inline-block;
                      border-bottom: 2px solid #fff;
                      cursor: pointer;
                      box-sizing: border-box;
                      .groupMemberName {
                        font-family: PingFangSC-Medium;
                        font-size: 16px;
                        color: #415af6;
                        letter-spacing: 0;
                        line-height: 24px;
                      }
                      .groupNum,
                      .relativeTask {
                        font-family: PingFangSC-Medium;
                        font-size: 16px;
                        color: #415af6;
                        letter-spacing: 0;
                        line-height: 24px;
                        margin-left: 15px;
                      }
                    }
                    .message-link-toSpecGroup:hover {
                      box-sizing: border-box;
                      border-bottom: 2px solid #415af6;
                    }
                  }
                  .message-title-media {
                    .title-media,
                    .relativeTask {
                      font-family: PingFangSC-Medium;
                      font-size: 16px;
                      color: #415af6;
                      letter-spacing: 0;
                      line-height: 24px;
                    }
                    .relativeTask {
                      margin-left: 15px;
                    }
                  }
                  .message-content {
                    margin-top: 8px;
                    font-family: PingFangSC-Regular;
                    font-size: 14px;
                    color: #666666;
                    letter-spacing: 0;
                    text-align: left;
                    line-height: 22px;
                  }
                  .message-footer-group {
                    overflow: hidden;
                    .checkContext {
                      float: right;
                      font-family: PingFangSC-Regular;
                      font-size: 14px;
                      color: #415af6;
                      letter-spacing: 0;
                      line-height: 14px;
                      text-decoration: underline;
                      margin-right: 18px;
                      display: none;
                      cursor: pointer;
                    }
                    .messageTime {
                      float: right;
                      font-family: PingFangSC-Regular;
                      font-size: 14px;
                      color: #c8c7cc;
                      letter-spacing: 0;
                      line-height: 14px;
                    }
                  }
                  .message-footer-media {
                    .message-footer-news {
                      overflow: hidden;
                      margin-top: 15px;
                      .message-footer-ls {
                        float: left;
                        width: 675px;
                        text-align: left;
                        display: flex;
                        justify-content: space-between;
                        .keywords-wrapper {
                          width: 225px;
                          font-family: PingFangSC-Regular;
                          font-size: 12px;
                          color: #999999;
                          letter-spacing: 0;
                          line-height: 22px;
                          .keywords {
                            color: #333333;
                          }
                        }
                        .frequency-wrapper {
                          width: 225px;
                          font-family: PingFangSC-Regular;
                          font-size: 12px;
                          color: #999999;
                          letter-spacing: 0;
                          line-height: 22px;
                          .frequency {
                            color: #333333;
                          }
                        }
                        .messageOrigin-wrapper {
                          width: 225px;
                          font-family: PingFangSC-Regular;
                          font-size: 12px;
                          color: #999999;
                          letter-spacing: 0;
                          line-height: 22px;
                          .messageOrigin {
                            color: #333333;
                          }
                        }
                      }
                      .message-footer-rs {
                        float: right;
                        width: 110px;
                        .similarArticle {
                          font-family: PingFangSC-Regular;
                          font-size: 12px;
                          color: #415af6;
                          letter-spacing: 0;
                          text-align: right;
                          cursor: pointer;
                          float: right;
                        }
                      }
                    }
                    .message-footer-weibo {
                      overflow: hidden;
                      margin-top: 15px;
                      .message-footer-ls {
                        float: left;
                        width: 57%;
                        text-align: left;
                        display: flex;
                        .fansNum-wrapper,
                        .commentNum-wrapper,
                        .likeNum-wrapper,
                        .forwardNum-wrapper {
                          font-family: PingFangSC-Regular;
                          font-size: 12px;
                          color: #999999;
                          letter-spacing: 0;
                          line-height: 22px;
                          flex: 1 0 0%;
                          span {
                            color: #333333;
                          }
                        }
                      }
                      .message-footer-rs {
                        float: right;
                        width: 105px;
                        .similarArticle {
                          font-family: PingFangSC-Regular;
                          font-size: 12px;
                          color: #415af6;
                          letter-spacing: 0;
                          text-align: right;
                          cursor: pointer;
                          float: right;
                        }
                      }
                    }
                    .message-footer-pubilc {
                      overflow: hidden;
                      margin-top: 15px;
                      .message-footer-ls {
                        float: left;
                        width: 675px;
                        text-align: left;
                        display: flex;
                        justify-content: space-between;
                        .publicAccount-wrapper {
                          width: 225px;
                          font-family: PingFangSC-Regular;
                          font-size: 12px;
                          color: #999999;
                          letter-spacing: 0;
                          line-height: 22px;
                          .publicAccount {
                            color: #333333;
                          }
                        }
                        .frequency-wrapper {
                          width: 225px;
                          font-family: PingFangSC-Regular;
                          font-size: 12px;
                          color: #999999;
                          letter-spacing: 0;
                          line-height: 22px;
                          .frequency {
                            color: #333333;
                          }
                        }
                        .author-wrapper {
                          width: 225px;
                          font-family: PingFangSC-Regular;
                          font-size: 12px;
                          color: #999999;
                          letter-spacing: 0;
                          line-height: 22px;
                          .author {
                            color: #333333;
                          }
                        }
                      }
                      .message-footer-rs {
                        float: right;
                        width: 110px;
                        .similarArticle {
                          font-family: PingFangSC-Regular;
                          font-size: 12px;
                          color: #415af6;
                          letter-spacing: 0;
                          text-align: right;
                          cursor: pointer;
                          float: right;
                        }
                      }
                    }
                    .message-footer-tieba {
                      margin-top: 15px;
                      width: 50%;
                      display: flex;
                      justify-content: space-between;
                      .author-wrapper,
                      .totalFloors-wrapper,
                      .postTime-wrapper {
                        flex: 1 0 225px;
                        font-family: PingFangSC-Regular;
                        font-size: 12px;
                        color: #999999;
                        line-height: 22px;
                        text-align: left;
                        span {
                          color: #333333;
                        }
                      }
                    }
                  }
                }
              }
              .listMessage-item:hover .checkContext {
                display: block !important;
              }
            }
          }
        }
        .section-page {
          .page;
          margin-top: 40px;
        }
      }
      .empty-placeholder {
        padding-top: 40px;
        font-size: 30px;
        font-weight: bolder;
        text-align: left;
        color: #333;
      }
    }
  }
}
</style>
